// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"1b0f0235","787":"ec704a7a"}[chunkId] + ".chunk.js";
};